export interface WicketApiResponse<T = Record<string, unknown>> {
  status: number;
  data?: T;
}
